import script from "./SettingsNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsNotifications.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NotificationRow from "@/components/settings/NotificationRow.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
script.components = Object.assign({}, { NotificationRow, SettingsSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NotificationRow, SettingsSection }, script.__o.components);}